<template>
    <div class="app-search">
        <v-select ref="bar" :options="routes" label="title" select-on-tab placeholder="Tüm Uygulamada Ara" v-model="selected" :dropdown-should-open="openControl" v-on:option:selected="onSelect">
            <template v-slot:option="option">
                <div class="d-flex align-items-center">
                    <span class="material-icons-outlined mr-1 text-secondary">{{option.icon}}</span>
                    <div>
                        <div class="app-serach-parent-title text-muted" v-if="option.parentTitle">{{option.parentTitle}}</div>
                        <span>{{ option.title }}</span>
                    </div>
                </div>
            </template>
            <template #open-indicator>
                <v-short-key :combination="['CTRL','SHIFT','F']"></v-short-key>
                <span class="material-icons-outlined text-secondary ml-50">search</span>
            </template>
            <template #no-options="{ search }">
                <template v-if="search">
                    Aradığınız sayfa <strong>({{search}})</strong> bulunamadı.
                </template>
                <template v-else>
                    Sayfalar yüklenirken hata oluştu.
                </template>
            </template>
        </v-select>
    </div>
</template>

<script>
import navigation from '@/navigation/vertical/new-index'
import useVerticalNavMenu from '../layout-vertical/components/vertical-nav-menu/useVerticalNavMenu'
import VShortKey from '@/components/VShortKey.vue'

export default {
    components:{
        VShortKey
    },
    data(){
        return {
            options:[
                {Name:'sa'}
            ],
            selected:null
        }
    },
    methods:{
        openControl({noDrop, open, mutableLoading}) {
            return noDrop ? false : open && !mutableLoading 
        },
        onSelect(option){
            if(option.route && this.$route.name != option.route){
                    this.$router.push({name:option.route})
                    this.selected = null
                    useVerticalNavMenu().collapse(true)
            }else this.selected = null
        },
    },
    mounted(){
        window.addEventListener("keydown",(e) => {
            if ((e.ctrlKey && e.shiftKey && e.code === 'KeyF') || (e.metaKey && e.shiftKey && e.code === 'KeyF')) { 
                e.preventDefault();
                this.$refs.bar?.$refs?.search?.focus()
            }
        })
    },
    computed:{
        routes(){
            let categories = navigation.categories.filter(n=>n.route)
            let items = navigation.items.reduce((arr,item)=>{
                if(item.children){
                    item.children.forEach(child => arr.push({
                        ...child,
                        parentTitle:[navigation.categories.find(c=>c.key == item.category)?.title || null,item.title].join(' > '),
                    }))
                }else arr.push({
                    ...item,
                    parentTitle:navigation.categories.find(c=>c.key == item.category)?.title
                })
                return arr
            },[]).filter(i=>i.visible)
            return [...categories,...items]
        }
    }
}
</script>

<style>
.app-serach-parent-title{
    font-size: 0.75rem;
}
.app-search .v-select ul::-webkit-scrollbar{
    display: none;
}
.app-search .v-select.vs--open .vs__dropdown-toggle{
    border-color:var(--secondary);
}
.app-search .v-select.vs--open .vs__search::placeholder{
    color: var(--secondary);
}
.app-search .vs__dropdown-option.vs__dropdown-option--highlight{
    background: rgb(239, 91, 12,0.1);
    color: var(--secondary) !important;
}
</style>